module.exports = __webpack_public_path__ + "img/emptyboard.5fa04123.svg";